import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Globals } from '../../globals';

@Injectable({
  providedIn: 'root',
})
export class OrdersService {
  private readonly client = inject(HttpClient);
  private readonly globals = inject(Globals);


  cancelRecurringPayment(orderId: number): Observable<boolean> {
    const url = `${this.globals.apiRoot}/jwtorders/${orderId}/payment/`;
    return this.client.delete<boolean>(url);
  }

  getStatus(orderNo: string): Observable<Order> {
    const url = `${this.globals.apiRoot}/jwtorders/${orderNo}/status/`;
    return this.client.get<Order>(url);
  }
}

export interface Order {
  id?: number;
  orderNo?: string;
  status?: string;
  validUntil?: string;
  added?: string;
  cancelled?: string;
  renewed?: string;
}
